
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

// /yangcheng-test/Interactive 发布互动咨询 post
// /yangcheng-test/Interactive/{id} 根据唯一id get
/**
 * 睦邻首页显示 睦邻首页列表查询
 * @returns
 */
export const getInteractiveHomeList = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/Interactive/GetHomeList`, { params: data })
}
//前端列表分页查询
export const getInteractive = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/Interactive`, { params: data })
}
//前端列表分页查询
export const getInteractiveById = (id: string): any => {
    return axios.get(`${baseURL}/Interactive/${id}`)
}